import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { ChevronDown, LogOut } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { format } from 'date-fns';
import { sv } from 'date-fns/locale';

export function AccountSettingsCard() {
  const { user, signOut } = useAuth();
  const [accountOpen, setAccountOpen] = useState(false);

  const createdAt = user?.created_at
    ? format(new Date(user.created_at), 'd MMMM yyyy', { locale: sv })
    : '–';

  const lastSignIn = user?.last_sign_in_at
    ? format(new Date(user.last_sign_in_at), 'd MMMM yyyy', { locale: sv })
    : '–';

  return (
    <Collapsible open={accountOpen} onOpenChange={setAccountOpen}>
      <CollapsibleTrigger className="flex w-full items-center justify-between py-2 text-sm font-medium text-muted-foreground/70 hover:text-muted-foreground transition-colors">
        Konto &amp; inställningar
        <ChevronDown
          className={`h-3.5 w-3.5 transition-transform ${accountOpen ? 'rotate-180' : ''}`}
        />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <Card className="mt-3 border-border/60 shadow-none">
          <CardContent className="p-5 sm:p-6 space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-muted-foreground">E-post</span>
              <span className="text-foreground truncate ml-4 text-right">{user?.email}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Konto skapat</span>
              <span className="text-foreground">{createdAt}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Senast inloggad</span>
              <span className="text-foreground">{lastSignIn}</span>
            </div>
            <div className="pt-3 border-t border-border/40">
              <Button
                variant="ghost"
                size="sm"
                className="w-full justify-start text-muted-foreground hover:text-foreground"
                onClick={() => signOut()}
              >
                <LogOut className="mr-2 h-4 w-4" />
                Logga ut
              </Button>
            </div>
          </CardContent>
        </Card>
      </CollapsibleContent>
    </Collapsible>
  );
}
